<template>
  <div v-if="count > 0" :class="{'hidden':hidden}" class="box">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrollTo from '@/utils/scroll-to';

export default {
  name: 'Pagination',
  props: {
    count: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    size: {
      type: Number,
      default: 10,
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    background: {
      type: Boolean,
      default: true,
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pageSizes: [10, 20, 31],
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      },
    },
    pageSize: {
      get() {
        return this.size;
      },
      set(val) {
        this.$emit('update:size', val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('page-change', { page: this.currentPage, size: val });
      if (this.autoScroll) scrollTo(0, 350);
    },
    handleCurrentChange(val) {
      this.$emit('page-change', { page: val, size: this.pageSize });
      if (this.autoScroll) scrollTo(0, 350);
    },
  },
  mounted() {
    if (this.isAdministrator) this.pageSizes = [10, 20, 31, 200];
  },
};
</script>

<style scoped>
.box {
  padding: 16px;
  background: #fff;
}

@media screen and (min-width:1200px) {

}
@media screen and (min-width: 960px) and (max-width: 1199px) {

}
@media screen and (min-width: 768px) and (max-width: 959px) {

}
@media only screen and (min-width: 480px) and (max-width: 767px){

}
@media only screen and (max-width: 479px) {
  .box {
    padding: 5vw;
    background: transparent;
  }

  /deep/.el-pagination {
    box-sizing: border-box;
    width: 90vw;
    padding: 5vw;
    display: flex;
    flex-wrap: wrap;
    background: #fff;
  }
  /deep/.el-pagination__total {
    width: 20vw;
    margin-right: 0;
  }
  /deep/.el-pagination__sizes {
    width: 60vw;
    margin: 0;
  }
  /deep/.el-pager {
    width: 95vw;
    margin: 3vw 0;
  }
}
</style>
